// Force the admin console to English. The @adornis framework packages default to `baseLocale="de"`
// and resolve the locale from the shared `PARAGLIDE_LOCALE` cookie first; this app has no language
// switch and never sets it, so the framework chrome renders in German. Setting the cookie to "en"
// here (imported before any framework module in client/startup.ts) makes every runtime resolve English.
if (typeof document !== 'undefined') {
  const oneYear = 60 * 60 * 24 * 365;
  document.cookie = `PARAGLIDE_LOCALE=en; path=/; max-age=${oneYear}; samesite=lax`;
}
